export const DATEPICKER_DEFAULT_FORMAT = 'dd.MM.yyyy'
export const STOP_SALES_DATE_FORMAT = 'yyyy-MM-dd'
export const PRICE_LIST_SEASON_RANGE_FORMAT = 'ddMMMyyyy'
export const CAR_RENTAL_DAYS = 'yyyy-MM'
export const CAR_RENTAL_DAYS_TABLE = 'MMM, yyyy'
export const CAR_RENTAL_DAYS_TABLE_ONE_YEAR = 'MMM'
export const DASHBOARD_DIAGRAM_FORMAT = 'dd MMM yyyy'
export const DOCUMENTS_UPDATE_FORMAT = 'dd MMMM yyyy'
